import { getLookupFromLocalStorage } from '../helpers/utils';

export default {
  providers: getLookupFromLocalStorage('providers'),
  billStatuses: getLookupFromLocalStorage('billStatuses'),
  objectionReasons: getLookupFromLocalStorage('objectionReasons'),
};
